<template>
  <Flex
    :class="{
      'router-link-exact-active':
        isCurrentMeasure(this.$route.query.measures) && !this.$route.query.calculated,
    }"
  >
    <Flex :class="{ 'cursor-pointer': true }">
      <router-link class="measure-link" :to="getRoute(measure, selectedSubOption)">
        {{ $t(measure.name) }}
      </router-link>
    </Flex>
    <DropDown :options="measure.subOptions" @updateOption="onSubOptionUpdate" />
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import { isEqual } from 'lodash'
import DropDown from '@/components/DropDown'

export default {
  name: 'MeasureSingleSelector',
  components: {
    Flex,
    DropDown,
  },
  props: {
    measure: Object,
  },
  data() {
    return {
      showMenu: false,
      selectedSubOption: this.measure.subOptions[0],
    }
  },
  methods: {
    onSubOptionUpdate(newSubOption) {
      this.selectedSubOption = newSubOption
      const route = this.getRoute(this.measure, this.selectedSubOption)
      if (!isEqual(this.$route.query, route.query)) {
        this.$router.push(route)
      }
    },
    getRoute(measure, subOption) {
      const measureFunction = subOption?.attributeValue || 'count'
      const newMeasures = [].concat(`${measureFunction}(${measure.attributePath})`)
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          measures: newMeasures,
          calculated: false,
        },
      }
      return route
    },
    isCurrentMeasure(measures) {
      return measures && this.measureAttribute(measures[0]) === this.measure.attributePath
    },
    measureAttribute(fullMeasure) {
      if (fullMeasure && fullMeasure.length > 0) {
        return fullMeasure.substring(fullMeasure.indexOf('(') + 1, fullMeasure.indexOf(')'))
      }
      return ''
    },
  },
}
</script>

<style lang="postcss" scoped>
.measure-link {
  @apply break-words text-primary-500;
}
</style>
